export default {
  'system.title': 'MetaGala',
  'system.sub-title': 'Organizer Platform',
  'system.main.title': 'MetaGala',
  'system.client.title': 'Click Here To Access Your Virtual Event',
  'login.tab.account.title': 'Account Login',
  'login.tab.code.title': 'Verification Code Login',
  'login.account': 'Account',
  'login.account.placeholder': 'Please enter your account',
  'login.password': 'Password',
  'login.password.erro': 'account or password erro',
  'login.password.placeholder': 'Please enter your password',
  'login.email': 'Email / Mobile Number',
  'login.email.placeholder': 'Please enter your email/mobile number',
  'login.email.checked.erro.info': 'Please enter a valid email or phone number',
  'login.code': 'Verification code',
  'login.code.sent.error': 'This account is not a configuration administrator for any event. Please verify the configuration administrator’s email or phone number. If you need to log in to participate in the event, please visit',
  'login.code.placeholder': 'Please enter the verification code',
  'login.code.reget': 'Wait {seconds} sec',
  'login.code.send.success': 'Verification code send success！',
  'login.get.code': 'Sent',
  'login.code.erro': 'Email or Phone or verification code erro',
  'login': 'Login',

  'menu.organizational.management': 'Organizational',
  'menu.account.management': 'Account',
  'menu.meeting.management': 'Event',
  'menu.meeting.my-meeting': 'Home',
  'menu.meeting.lead': 'Event Application',
  'menu.meeting.meeting-invitation': 'Event Invitation',
  'menu.meeting.meeting-invitation-list': 'Event Invitation Record',
  'menu.meeting.name-list': 'List Management',
  'menu.meeting.feedback': 'Feedback',
  'menu.meeting.egg': 'Egg Record',
  'menu.meeting.paper-survey': 'Paper Survey',
  'menu.meeting.configuration': 'Event Configuration',
  'menu.meeting.sign-in': 'Sign-in Records',
  'menu.meeting.data.reporting': 'Data Reporting',
  'menu.meeting.minutes': 'Event Minutes',
  'menu.meeting.invitations': 'Invite to Attend',
  'menu.meeting.request.deletion': 'Request Deletion',
  'menu.resources.management': 'Resource Management',
  'menu.resources.series': 'Resource Series',

  'role.super': 'Super Administrator',
  'role.business': 'Business Administrator',
  'role.configuration': 'Configuration Administrator',
  'role.default': 'Administrator',

  'table.organizational': 'Organization ',
  'table.organizational.create': 'Create Organization',
  'table.organizational.name': 'Organizational Name',
  'table.organizational.buy.meeting.count': 'Number of Events Purchased',
  'table.organizational.used.meeting.count': 'Number of Events Used',
  'table.organizational.meeting.stop.timeline': 'Event Usage Deadline',
  'table.organizational.meeting.end.date': 'Event Usage Deadline',
  'table.organizational.status': 'Status',
  'table.organizational.create_by': 'Creator',
  'table.organizational.create_time': 'Creation Datetime',
  'table.organizational.update_by': 'Update people',
  'table.organizational.update_time': 'Update Datetime',
  'table.organizational.remark': 'Remark',

  'table.account': 'Account Information',
  'table.account.create': 'New Account',
  'table.account.administrator': '	Administrator Name',
  'table.account.email': 'Administrator Email',
  'table.account.mobile': 'Administrator Mobile Number',
  'table.account.confirm.delete.info': 'Are you sure you want to delete this account?',
  'table.account.username': 'User Name',
  'table.account.avatar': 'Avatar',
  'table.account.password': 'Password',
  'table.account.login_ip': 'Login ip',
  'table.account.login_date': 'Login Datetime',
  'table.account.is_admin': 'Is Administrator',
  'table.account.deleted': 'Is Deleted',
  'table.account.role_key': 'Role Code',
  'table.account.mobile.phone': 'Mobile Phone Number',

  'table.meeting': 'Event ',
  'table.meeting.id': 'Event  ID',
  'table.meeting.create': 'Create Event ',
  'table.meeting.name': 'Event  Name',
  'table.meeting.name.required': 'Please select a event',
  'table.meeting.administrator': 'Administrator',
  'table.meeting.status': 'Event  status',
  'table.meeting.customer.name': 'Client Name',
  'table.meeting.number': 'Event  Number',
  'table.meeting.link': 'Event  Link',
  'table.meeting.creation.time': 'Creation time',
  'table.meeting.opening.time': 'System Opening Time',
  'table.meeting.shutdown.time': 'System Closing Time',
  'table.meeting.attendees.number': 'Number of Participants',
  'table.meeting.administrator.account': 'Administrator Account',
  'table.meeting.confirm.delete.info': 'Confirm the deletion of this event schedule',
  'table.meeting.no.start': "Not Started",
  'table.meeting.on.going': 'In Progress',
  'table.meeting.Ended': 'Completed',
  'table.meeting.managed.self': 'Event s managed by me',
  'table.meeting.time.zone': 'Time Zone',
  'table.meeting.time.zone.show': 'Time Zone Show',
  'table.meeting.time.zone.name': 'The name of the time zone',
  'table.meeting.time': 'Event  Time',
  'table.meeting.time.start': 'Start time',
  'table.meeting.time.end': 'End time',
  'table.meeting.time.availability': 'System Availability Time',
  'table.meeting.time.open': 'System opening hours',
  'table.meeting.time.open.suggestion': 'Recommend that the system availability time should be at least half an hour earlier than the event time',
  'table.meeting.time.close.suggestion': 'Suggested that the system end time should be at least half an hour later than the event end time',
  'table.meeting.started.cannot.deleted': 'The event has already started and cannot be deleted',
  'table.meeting.confirm.deletion': 'Confirm deletion of this event arrangement',
  'table.meeting.apply.confirm.deletion': 'Confirm deletion of this event arrangement',
  'table.meeting.apply.confirm.deletion.user': 'Applicant',
  'table.meeting.started.cannot.confirm': 'The event has already started and cannot be configured',
  'table.meeting.type': 'Type',
  'table.meeting.account.type': 'Category',
  'table.meeting.title': 'Event  Subject',
  'table.meeting.title.tip': 'Please enter the event theme, and it will be automatically inserted into the body of the invitation below',
  'table.meeting.bulk.mailing.list': 'Enter The Mass Email List',
  'table.meeting.bulk.phone.list': 'Mass Texting Mailing List​',
  'table.meeting.cc': 'CC',
  'table.meeting.send': 'Send',
  'table.meeting.mail.content': 'Invitation Information',
  'table.meeting.SMS.content': 'The content of the text message',
  'table.meeting.insert.link': 'Insert Event  Link',
  'table.meeting.insert.ID': 'Insert Event  ID',
  'table.meeting.insert.time': 'nsert Event  Time',
  'table.meeting.mail.save.change': 'Save Draft',
  'table.meeting.radio.all': 'All Event s',
  'table.meeting.radio.no.start': 'Upcoming Events',
  'table.meeting.radio.on.going': 'Ongoing Events',
  'table.meeting.radio.Ended': 'Completed Events',
  'table.meeting.review': 'Whether it is a "closed-door event": Participants not on the whitelist need to pass the review before entering the event venue.',
  'table.meeting.seat.number': 'Seating Capacity (Please select, required)',
  'table.meeting.only.not.started': "Only events that haven't started are displayed",
  'table.meeting.organizationalselect.name': 'Name',
  'table.meeting.organizationalselect.attempts': 'Remaining Attempts',
  'table.meeting.organizationalselect.deadline': 'Deadline',

  'table.name.lead.company': 'Company Name',
  'table.name.lead.fullname': 'Name',
  'table.name.lead.position': 'Position',
  'table.name.lead.phone_number': 'Mobile Phone',
  'table.name.lead.email': 'Email',
  'table.name.lead.try_time': 'Start Time',
  'table.name.lead.end_time': 'End Time',
  'table.name.lead.select.0': 'Pending Review',
  'table.name.lead.select.1': 'Approved',
  'table.name.lead.select.2': 'Rejected',
  'table.name.lead.command.approved': 'Approved',
  'table.name.lead.command.approved.info': 'Are you sure you want to approve this application?',
  'table.name.lead.command.rejected': 'Rejected',
  'table.name.lead.command.rejected.info': 'Are you sure you want to reject this application?',

  'meeting.step.basic': 'Basic Configuration',
  'meeting.step.image': 'Select Scene',
  'meeting.step.image.title': 'Visual Scene Configuration',
  'meeting.step.venue': 'Scene Selection',
  'meeting.step.outfit': 'Clothing Selection',
  'meeting.step.outfit.title': 'Clothing',
  'meeting.step.product': '3D Display (Optional)',
  'meeting.step.product.title': 'Interactive 3D Display (Optional: None / Multiple)',
  'meeting.step.client': 'Image & Video Configuration',
  'meeting.step.special': 'Special Role Configuration',
  'meeting.step.egg': 'Easter Egg（Optional）',

  'meeting.scene.operate.move': 'Use WASD to move, QE to move up/down',
  'meeting.scene.operate.rotate': 'Hold Left Click and drag to rotate view, Arrow keys to rotate view',
  'meeting.scene.image': 'Please select the image configuration scenario',
  'meeting.scene.image.iceberg': 'Iceberg',

  'meeting.scene.select': 'Please select a scene',
  'meeting.scene.seat.number': 'Please select the number of seats',
  'meeting.scene.show.all': 'Show All Scenes',
  'meeting.scene.select.tip': 'Please click the scene icon below to select and preview the scene',
  // 'meeting.scene.desert':'Desert',
  'meeting.scene.desert.descr': 'Desert Login Screen',
  // 'meeting.scene.haiyun.mirage':'Sea Fantasy Realm',
  'meeting.scene.room.meeting': 'Indoor Event Room',
  'meeting.scene.book.meeting': 'Book-themed Event Room',
  // 'meeting.scene.underwater.meeting':'Underwater World',
  // 'meeting.scene.racing.meeting':'Racing Car Conference Room',
  // 'meeting.scene.iceberg':'Iceberg',
  // 'meeting.scene.professional':'Professional Event Room',

  // 20250825更新
  'meeting.scene.1': 'Dazzling Night Stage',
  'meeting.scene.1-1': 'Professional Event Hall',
  'meeting.scene.2': 'Desert Dunes Landing',
  'meeting.scene.3': 'Business Modern',
  'meeting.scene.4': 'Booklit Flow',
  'meeting.scene.5': '	Underwater Fantasy',
  'meeting.scene.6': 'Microcosm Speed',
  'meeting.scene.7': 'Boundless Deep',

  'meeting.clothing.select': 'Please select a clothing line',
  'meeting.clothing.casual': 'Casual series',
  'meeting.clothing.cyber': 'Cyber series',
  'meeting.clothing.business': 'Business Series',
  'meeting.clothing.racing': 'Racing series',

  'meeting.client.scenarios': 'Functional Scenarios',
  'meeting.client.color': ' Color Scheme',
  'meeting.client.login.image': 'Login Page Background Image',
  'meeting.client.venue.image': 'Venue Main Image',
  'meeting.client.venue.image.big.screen': 'Large-Screen Main Image',
  'meeting.client.venue.image.big.screen.tip': 'Please upload the main image',
  'meeting.client.warm.video': 'Warm-up Video',
  'meeting.client.signature.wall': 'Background Image for Signature Wall',
  'meeting.client.ai': 'AI Generation',
  'meeting.client.ai.title': 'Generate your exclusive event theme poster',
  'meeting.client.ai.tip1': 'Click and then enter a description of the image you want to generate',
  'meeting.client.ai.tip2': 'For example: color, style, scene, etc',
  'meeting.client.ai.tip3': 'Create Image',
  'meeting.client.ai.tip4': 'Prompt',
  'meeting.client.ai.tip4.request': 'Please enter the prompt',
  'meeting.client.ai.tip5': 'Describe your ideal signature wall theme poster',
  'meeting.client.ai.tip6': 'Add LOGO',
  'meeting.client.ai.tip7': 'Generate Image',
  'meeting.client.ai.tip8': 'Generated Results',
  'meeting.client.ai.tip9': 'Confirm to use this image',
  'meeting.client.ai.times': 'Current Meeting Times Used Up',

  'meeting.account.speaker': 'Guest Speaker',
  'meeting.account.administrator': 'Event Stage Manager',
  'meeting.account.recording': 'Event Recording',
  'meeting.account.create': 'Add Account',
  'meeting.account.confirm.configuration': 'Confirm the configuration',
  'meeting.account.image.type': 'Guest Speaker Avatar',
  'meeting.account.diy.image': 'DIY Image',
  'meeting.account.customize.image': 'Customized Image',
  'meeting.account.NPC.role': 'General Guest Speaker',
  'meeting.account.sign.method': 'Login Method',
  'meeting.account.delete.confirm': 'Do you want to delete the user?',
  'meeting.account.add.least.one': 'Please add at least one event stage manager account',
  'meeting.account.save.erro.account.unique': 'Accounts are not unique，Please confirm！',

  'meeting.SMS.participated.info': 'You participated',
  'meeting.SMS.follows.info': 'The information is as follows',
  'meeting.SMS.join.info': 'Click on the link to join',
  'meeting.send.success': 'Sent successfully！',
  'meeting.has.many.email': 'If there are multiple email addresses, separate them with a semicolon (;)',
  'meeting.has.many.sms': 'If there are multiple text messages, separate them with a semicolon (;)',
  'meeting.copy.all': 'Copy All',
  'meeting.copy.link': 'Copy Link and Event ID',
  'meeting.send.invitation.email': 'Send Invitation Email',
  'meeting.invitation.setting': 'The current event is not yet configured. Go to configure',

  'table.name.manage.review': 'Only Display The Pending Review List',
  'table.name.manage.registration': 'Registration Roster',
  'table.name.manage.registration.tip': 'For closed-door events, there is an applicant list for participation; for open events, this information is not applicable',
  'table.name.manage.special': 'Special Role',
  'table.name.manage.special.tip': 'Guest Speaker, Event Controller, Event Recording List​',
  'table.name.manage.type': 'Role Category',
  'table.name.manage.whitelist': 'Whitelist',
  'table.name.manage.whitelist.tip': 'Closed-door Event Attendee Whitelist',
  'table.name.manage.allowed': 'Authorized to Attend',
  'table.name.manage.allowed.tip': 'For closed-door events, there is an approved attendee list; for open events, this information is not applicable',
  'table.name.manage.period': 'Registration Period',
  'table.name.manage.invited': 'Invited OR Not',
  'table.name.manage.review.status': 'Review status',
  'table.name.manage.invited.time': 'Invitation Time',

  'resource.action': 'Action',
  'resource': 'Resource',
  'resource.name': 'Resource Name',
  'resource.affiliation': 'Organization',
  'resource.description': 'Description',
  'resource.Cover.file.name': 'Cover File Name',
  'resource.resource.file.name': 'Resource File Name',
  'resource.preview.video': 'Video Preview',
  'resource.robot.coordinates': 'Robot coordinates',
  'resource.camera.position': 'Camera position',
  'resource.hdr.file': 'hdr File',
  'resource.seats.Number': 'Seating Capacity',
  'resource.clothing': 'Clothing',
  'resource.clothing.casual': 'Casual',
  'resource.clothing.cyber': 'Cyber',
  'resource.clothing.business': 'Business',
  'resource.clothing.racing': 'Racing',
  'resource.clothing.hairstyle': 'Hairstyle',
  'resource.clothing.head': 'Head',

  'series': 'Series',
  'series.add.new': 'Add a new series',
  'series.name': 'Series Name',
  'series.name.required': 'Please enter a series name',
  'series.preview.image': 'Preview Image',
  'series.preview.image.required': 'Please upload a preview image',

  'analysis.select.duration': 'User Event Duration',
  'analysis.select.remarks': 'User Remarks',
  'analysis.select.questions': 'User Questions',
  'analysis.select.chat': 'Administrator Chat Records',
  'analysis.select.product': 'Interactive 3D Display Records',
  'analysis.select.summary': 'Event Summary',

  'analysis.table.user.name': 'User Name',
  'analysis.table.company.name': 'Company Name',
  'analysis.table.login.time': 'First Login Time',
  'analysis.table.logout.time': 'Last Logout Time',
  'analysis.table.online.duration': 'Total Online Duration',
  'analysis.table.login_count': 'Login Count',
  'analysis.table.hrn.apply.count': 'Image apply count',
  'analysis.table.hrn.success.count': 'Image success count',


  'analysis.table.speak.count': 'Number of Speeches',
  'analysis.table.total.speak.time': 'Cumulative Speech Duration',
  'analysis.table.view.count': 'View Count',
  'analysis.table.view.duration': 'Total View Duration',

  'goods.animation.config': 'Animation Configuration',
  'goods.animation.id': 'Animation Number',
  'goods.animation.name': 'Animation Name',
  'goods.animation.add': 'Add',
  'goods.animation.model': 'Animation Model',

  'common.logout': `logout`,
  'common.button.ok': `Confirm`,
  'common.export': `​Export with One Click`,
  'common.button.save': `Save`,
  'common.button.cancel': `Cancel`,
  'common.button.add': `Add`,
  'common.button.upload.cover.image': `Click To Upload The Cover Image`,
  'common.button.upload.cover.video': `Click To Upload The Preview Video`,
  'common.button.effect.immediately': `Which Will Take Effect Immediately`,
  'common.import': "Import ",
  'common.button.search': `Search`,
  'common.data.total': `Number of Records`,
  'common.data.total.unit': " ",
  'common.data.page.size': `Page`,
  'common.operation': `Actions`,
  'common.edit': `Edit`,
  'common.delete': `Delete`,
  'common.confirm': `Confirm`,
  'common.confirm.delete': `Confirm Delete`,
  'common.confirm.delete.info': `Enter “<b>Delete</b>” in the box, and then click the Confirm button`,
  'common.confirm.apply.delete.info': `Enter “<b>Agree</b>” in the box, and then click the Confirm button`,
  'common.input.erro.info': `Input Error`,
  'common.enter.please': `Please enter `,
  'common.select.please': `Please select `,
  'common.lang.chinese': `Chinese`,
  'common.lang.english': `English`,
  'common.lang.chinese.simplified': `Simplified Chinese`,
  'common.name': `Name`,
  'common.mobile': `Mobile Phone`,
  'common.email': `Email`,
  'common.copy.link': `Copy Link`,
  'common.reset': `Reset`,
  'common.search': `Search`,
  'common.phone': `Phone Number`,
  'common.copy': `Copy`,
  'common.more': `More`,
  'common.de': ` of `,
  'common.agree': `Agree`,
  'common.SMS': `SMS`,
  'common.import': `Import`,
  'common.mailing.list': `Import Email List`,
  'common.company': `Company`,
  'common.refuse': `Refuse`,
  'common.pass': `Pass`,
  'common.all': `All`,
  'common.yes': `Yes`,
  'common.no': `No`,
  'common.go.back': `Go Back`,
  'common.next.step': `Next Step`,
  'common.previous.step': `Previous Step`,
  'common.to': `To`,
  'common.people': `People`,
  'common.preview': `Preview`,
  'common.example': `Example`,
  'common.proportion': `Aspect Ratio`,
  'common.label.proportion': `Aspect Ratio: `,
  'common.size': `Size`,
  'common.label.size': `The size is`,
  'common.file.size.less.than.25m': `The aspect ratio should be 16:9, the file size should be less than 25MB`,
  'common.format.mp4': `In MP4 format`,
  'common.video.size.exceed': `Video file exceeds 25MB. Please use a third-party tool to compress it before uploading`,
  'common.role': `Role`,
  'common.sex': `Gender`,
  'common.sex.female': `Female`,
  'common.sex.man': `Man`,
  'common.upload': `Upload`,
  'common.click.upload.image': `Click to Upload Image`,
  'common.click.upload.video': `Click to Upload Video`,
  'common.upload.tip': `Uploading，Please wait a moment...`,
  'common.upload.loading': `Uploading`,
  'common.upload.do.not.close': `Please do not close the page`,
  'common.upload.now': `Upload Now`,
  'common.upload.resource': `Please upload a resource file`,
  'common.upload.duplicate.file': `A file with the same name already exists. Please verify the file or rename it before saving`,
  'common.enter.file.name': `Please enter a file name`,
  'common.loading': `Loading...`,

  'common.request.name': `Please enter a name`,
  'common.request.role': `Please select a role`,
  'common.request.email': `Please enter your email address`,
  'common.request.phone': `Please enter your mobile phone number`,
  'common.request.image': `Please select an image asset`,
  'common.erro.email.format': `E-mail Format Erro`,
  'common.erro.phone.format': `Phone Format Erro`,
  'common.save.success': `Save Success！`,
  'common.erro.save.erro': `Save Failed：`,
  'common.title': `Name`,
  'common.time': `Time`,
  'common.file': `File`,
  'common.download.excel.template': `Download Excel Template`,
  'common.go.home': `Back to home`,
  'common.go.home.confirm': `You are sure back on the home page`,
  'common.account.save.erro.not.unique': 'There are already email or mobile phone number users，Please confirm！',
  'common.organizational.save.erro.not.unique': 'The same organization name already exists，Please confirm！',
  'common.audit': `Audit`,
  'common.copy.success': `Copy successful`,
  'common.copy.erro': `Unable to copy content. Please grant the browser permission to read the clipboard`,
  'common.please.check': `Please check`,
  'common.close': `Close`,
  'common.agree': `Agree & Acknowledge`,
  'common.hours': `hours`,
  'common.minutes': `minutes`,
  'common.seconds': `seconds`,
  'common.click.to.upload': `Click to Upload`,
  'common.data.sync': `Please check the "Data Report" after the event concludes. The data will be retained for 3 days.`,
  'common.zoom': `Zoom`,
  'common.rotate': `Rotate`,
  'common.remaining': `Remaining Times`,
  'feedback.content': 'Feedback Content',
  'feedback.image': 'Feedback Screenshot',
  'feedback.time': 'Feedback Time',
  'feedback.class': 'Class',
  'egg':'Egg',
  'egg.title': 'Egg Title',
  'egg.count': 'Egg Count',
  'egg.location': 'Egg Location',
  'egg.record': 'Egg Record',
  'egg.contact.name': 'Contact',
  'egg.contact.phone': 'Contact Phone',
  'egg.contact.address': 'Contact Address',  
  'egg.memo': 'Easter Egg Claim Instructions',
  'survey.page.title': 'Vote Title',
  'survey.page.description': 'Vote Description',
  'survey.page.status': 'Vote Status',
  'survey.page.status.in_progress': 'In Progress',
  'survey.page.status.ended': 'Ended',
  'survey.page.status.published': 'Published',
  'survey.page.question_type_1': 'Single Choice',
  'survey.page.question_type_2': 'Multiple Choice',
  'survey.page.fullname': 'Full Name',
  'survey.page.company': 'Company',
  'survey.page.account': 'Account',
  'survey.page.vote_time': 'Vote Time',
  'people_have_voted':'People Have Voted',
  'ticket': 'Ticket',
  'sign.in.page.username': 'User Name',
  'sign.in.page.name': 'Name',
  'sign.in.page.class': 'Class',
  'sign.in.page.signinTime': 'Sign-in Time',
  'sign.in.page.signinInstructions': 'Sign-in Instructions',
  'sign.in.page.signinDuration': 'Sign-in Duration',
  'sign.in.page.createdTime': 'Created Time',  
}
